// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-container {
  min-height: 100vh;
  background: linear-gradient(to bottom right, #f0f9ff, #e0f2fe);
  font-family: 'Poppins', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

* {
  box-sizing: border-box;
  margin: 0;
  padding: 0 5px;
}

body {
  overflow-x: hidden;
}

.tab-button {
  padding: 0.8rem 2rem;
  font-size: 1.1rem;
  font-weight: 600;
  border: none;
  background: transparent;
  border-radius: 50px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: 'Poppins', sans-serif;
}

.tab-button.active {
  background: #2563eb;
  color: white;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,8DAA8D;EAC9D,kCAAkC;EAClC,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,sBAAsB;EACtB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd","sourcesContent":[".app-container {\n  min-height: 100vh;\n  background: linear-gradient(to bottom right, #f0f9ff, #e0f2fe);\n  font-family: 'Poppins', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n* {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0 5px;\n}\n\nbody {\n  overflow-x: hidden;\n}\n\n.tab-button {\n  padding: 0.8rem 2rem;\n  font-size: 1.1rem;\n  font-weight: 600;\n  border: none;\n  background: transparent;\n  border-radius: 50px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-family: 'Poppins', sans-serif;\n}\n\n.tab-button.active {\n  background: #2563eb;\n  color: white;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
